import React, { FunctionComponent } from 'react'
import appSyncConfig from "../aws-exports";
import { AUTH_TYPE } from 'aws-appsync'
import { createAuthLink, AuthOptions } from 'aws-appsync-auth-link';
import { createSubscriptionHandshakeLink } from 'aws-appsync-subscription-link';
import { ApolloClient, ApolloLink, InMemoryCache, ApolloProvider } from '@apollo/client';

const url = appSyncConfig.aws_appsync_graphqlEndpoint;
const region = appSyncConfig.aws_appsync_region;
const auth = {
  type: AUTH_TYPE.API_KEY,
  apiKey: appSyncConfig.aws_appsync_apiKey,
} as AuthOptions;
const authLink = createAuthLink({ url, region, auth }) as any; // need to set to 'any' to avoid weird type conflicts
const handshakeLink = createSubscriptionHandshakeLink({ url, region, auth }) as any;
const link = ApolloLink.from([authLink, handshakeLink]);
export const client = new ApolloClient({
  link,
  cache: new InMemoryCache(),
  defaultOptions: {
    query: {
      fetchPolicy: 'no-cache'
    },
    watchQuery: {
      fetchPolicy: 'network-only'
    },
  }
})

const AppSyncClientProvider: FunctionComponent = ({ children }) => {
  return (
    <ApolloProvider client={client}>
      {children}
    </ApolloProvider>
  )

}
export default AppSyncClientProvider